import { render, staticRenderFns } from "./NsAside.vue?vue&type=template&id=e3b870b8&scoped=true&"
import script from "./NsAside.vue?vue&type=script&lang=js&"
export * from "./NsAside.vue?vue&type=script&lang=js&"
import style0 from "./NsAside.vue?vue&type=style&index=0&id=e3b870b8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3b870b8",
  null
  
)

export default component.exports